module.exports = __webpack_public_path__ + "media/images/mas-bf3b8d0da1f95da8e633d05ff860019a.svg";